import Jungle from '@/assets/jungle-2.jpg';
import { Heading, Paragraph } from '@/components/atoms';
import { AuthForm } from '@/components/molecules';
import { useIntl } from '@/intl';

// Supervisor pre-approval of cross-border assessments has been removed. The
// backend endpoint now always answers 410 Gone (PRE_APPROVAL_NO_LONGER_REQUIRED),
// so links from older pre-approval emails only show an informational notice.
const CBAPreapprove: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <AuthForm
      onSubmit={e => {
        e.preventDefault();
      }}
      imageSrc={Jungle}>
      <Heading type='h2'>
        {formatMessage({ id: 'cbaPreapprove.title' })}
      </Heading>
      <Paragraph className='font-medium'>
        {formatMessage({ id: 'cbaPreapprove.noLongerRequired' })}
      </Paragraph>
      <Paragraph variant='secondary'>
        {formatMessage({ id: 'cbaPreapprove.noLongerRequiredDescription' })}
      </Paragraph>
    </AuthForm>
  );
};

export default CBAPreapprove;
